<script setup lang="ts">
import CompetenceDomainIcon from '@/core/competences/CompetenceDomainIcon.vue';
import type { ICompetenceDisplayItem } from '@/core/competences/competenceDisplay.types';

const props = defineProps<{
  item: ICompetenceDisplayItem;
}>();

defineSlots<{
  trailing?(): void;
}>();
</script>

<template>
  <div class="flex min-w-0 items-center gap-md px-md py-sm">
    <CompetenceDomainIcon :color="props.item.domainColor" :icon-name="props.item.domainSymbol" />
    <span class="min-w-0 flex-1 truncate text-base text-primary" :title="props.item.description">
      {{ props.item.description }}
    </span>
    <div v-if="$slots.trailing" class="flex shrink-0 items-center">
      <slot name="trailing" />
    </div>
  </div>
</template>
